import { getCurrentInstance } from "vue";

/**
 * Hook pour utiliser les filtres globaux avec fallback SSR-safe
 */
export const useFilters = () => {
    const app = getCurrentInstance();
    const $filters = app?.appContext.config.globalProperties.$filters;

    const formatCurrency = (value: number, strict: boolean = true): string => {
        if (!$filters) {
            return new Intl.NumberFormat("fr-FR", {
                style: "currency",
                currency: "EUR",
                maximumFractionDigits: 0,
            }).format(value);
        }
        return $filters.currency(value, strict);
    };

    const formatNumber = (value: number): string => {
        if (!$filters) {
            return new Intl.NumberFormat("fr-FR").format(value);
        }
        return String($filters.number(value));
    };

    return {
        formatCurrency,
        formatNumber,
        // Expose l'objet filters original pour d'autres usages si nécessaire
        $filters,
    };
};
